import i18next from 'i18next';

import { deleteUser } from 'common/api/companies';
import alerts from 'common/modules/alerts';
import showToast from 'common/utils/showToast';

import {
    DELETE_USER,
    DELETE_USER_SUCCESS,
    DELETE_USER_FAILURE,
} from '../actionTypes';
import { companyUsersActions } from '../reducer';
import * as selectors from '../selectors';

import fetchUsers from './fetchUsers';
import resetForm from './resetForm';
import toggleModalUser from './toggleModalUser';

export default (userId) => (dispatch, getState) => {
    const filters = selectors.getFilters(getState());
    dispatch(companyUsersActions[DELETE_USER]());

    deleteUser(filters.id, userId)
        .then(() => {
            dispatch(companyUsersActions[DELETE_USER_SUCCESS](null));
            dispatch(alerts.actions.close());
            dispatch(
                fetchUsers(
                    filters.id,
                    filters.page,
                    filters.orderBy,
                    filters.sortBy,
                    filters.searchStr,
                ),
            );
            dispatch(toggleModalUser(false));
            dispatch(resetForm());

            showToast({ body: i18next.t('It was successfully removed') });
        })
        .catch((error) =>
            dispatch(
                companyUsersActions[DELETE_USER_FAILURE](
                    error?.response?.data?.errors,
                ),
            ),
        );
};
